import { Concept, Filter, Rank } from 'api/grpc/resources';

/** Zoom level where
 * -2 is farthest,
 *  2 is closest,
 *  0 is default */
export enum ZoomLevel {
  Farthest = -2,
  Far = -1,
  Default = 0,
  Close = 1,
  Closest = 2,
}

/**
 * Grid layout mode
 */
export enum LayoutMode {
  Grid = 'grid',
  Masonry = 'masonry',
}

export enum SrcType {
  Public = 'PUBLIC',
  App = 'APP',
  Unidentified = 'UNIDENTIFIED',
}

export enum SearchBarState {
  Editing = 'EDITING',
  Tokenized = 'TOKENIZED',
}

export enum HighlightColor {
  Blue = '#195aff',
  Grey = '#667085',
}

interface SearchToken {
  text: string;
  color: HighlightColor;
  conceptSrcType: SrcType;
  conceptId: string;
}

export interface InputQuery {
  userOrOrgId: string;
  appId: string;
  filters: Filter[];
  ranks: Rank[];
}

export const LOCAL_STORAGE_LAYOUT_MODE = 'LOCAL_STORAGE_LAYOUT_MODE';
export const LOCAL_STORAGE_ZOOM_LEVEL = 'LOCAL_STORAGE_ZOOM_LEVEL';

export const MULTIMODAL_EMBEDDER = 'multimodal-embedder';
export const UNIVERSAL_WORKFLOW = 'Universal'; // 'Universal-beta';
export const SWITCH_TO_UNIVERSAL_SMART_SEARCH_MODAL_ID = 'universal-smart-search-modal';
export const TEXT_EMBEDDER = 'text-embedder';

interface SerializedConcept {
  appId: string;
  userId: string;
  id: string;
  name: string;
}

/**
 * SmartSearchState is a serializable representation of the state of the smart search bar.
 */
export interface SmartSearchState {
  searchText: string;
  searchBarState: SearchBarState;
  publicConcepts: SerializedConcept[];
  appConcepts: SerializedConcept[];
  searchTokens: SearchToken[];
}

export const InitialSmartSearchState: SmartSearchState = {
  searchText: '',
  searchBarState: SearchBarState.Editing,
  publicConcepts: [],
  appConcepts: [],
  searchTokens: [],
};

export function deserializeConcept(sc: SerializedConcept): Concept {
  const c = new Concept();
  c.setUserId(sc.userId);
  c.setAppId(sc.appId);
  c.setId(sc.id);
  c.setName(sc.name);
  return c;
}

export interface AsymmetricalSearchPromptT {
  selected: boolean;
  value: string;
}
